export const INVOICE = 'INVOICE';
export const APPLE_PAY = 'APPLE_PAY';
export const CREDIT_CARD = 'credit_card';
export const CREDIT_POINTS = 'CREDIT_POINTS';

export const CREDIT_PAYMENT_TYPE_ID = '-3';
